module.exports = __webpack_public_path__ + "img/cart-icon.261cd1cc.svg";